<!-- Zweck: Stellt die HTML-Struktur für shop ajax warenkorb component im Frontend bereit. -->
@if ((warenkorb|async)) {
  <div class="ajax-warenkorb">
    <div class="paddedcontent">
      <h3>
        <svg-icon>warenkorb</svg-icon>
        <span> {{'Warenkorb ' + (warenkorb|async)?.label}}</span>
      </h3>
    </div>
    <div style="position: relative">
      <warenkorb-box [ajax_mode]="true" [warenkorb]="warenkorb|async"></warenkorb-box>
    </div>
  </div>
}
@if (!(warenkorb|async)) {
  <div style="text-align: center; padding-top: 50px">
    <div style="display: inline-block">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
